// extracted by mini-css-extract-plugin
module.exports = {"container":"_2lYl5","dot":"WbfPX","small":"_1LBs-","opacitychange":"_2lZVj"};